import { Box, BoxProps } from "@chakra-ui/react";

export const SendIcon = (props: BoxProps) => (
  <Box {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5399 2.54378C15.7249 0.589144 2.07223 5.37734 2.0835 7.12551C2.09628 9.1079 7.41523 9.71777 8.88952 10.1314C9.77607 10.3801 10.0135 10.6351 10.2179 11.5647C11.1438 15.7751 11.6086 17.8692 12.668 17.916C14.3566 17.9906 19.3113 4.45134 17.5399 2.54378Z"
        stroke="white"
        stroke-width="1.25"
      />
      <path
        d="M9.5835 10.4167L12.5002 7.5"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </Box>
);
